import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Step = makeShortcode("Step");
const CallToAction = makeShortcode("CallToAction");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Step checkpoint title="Verify source map upload" mdxType="Step">
      <p>{`Confirm that source maps are successfully uploaded to PostHog. `}</p>
      <CallToAction className="my-2" size="sm" type="secondary" to="https://app.posthog.com/settings/project-error-tracking#error-tracking-symbol-sets" external={true} mdxType="CallToAction">
    Check symbol sets in PostHog
      </CallToAction>
    </Step>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      